import React from "react";

import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";

const ReviewModel = ({ toggle=()=>{} , isOpen = false  }) => {
  return (
    <Modal className="submit-no-data review-model" isOpen={isOpen} toggle={toggle} >
      <ModalBody>
        <p>
          You have not fully completed your profile and this may cause delays in
          your recruitment process. Please review and complete your profile.
        </p>
        <p>On completion you will get a confirmation Email</p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={(e)=>toggle(e,"download")}>Download </Button>
        <Button color="secondary" onClick={toggle}>Review </Button>
        <Button color="secondary" onClick={(e)=>toggle(e , "ok_submit")} >It’s ok I’ll Submit </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ReviewModel
